import { useEffectOnce } from 'react-use';
import { loadCollectionsAsync } from '../../data-layer/collections/actions';
import {
    selectCollections,
    selectCollectionsLoading,
} from '../../data-layer/collections/selectors';
import { CollectionModel } from '../../data-layer/collections/types';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';

export interface UseCollectionsControllerPayload {
    collections: CollectionModel[];
    isLoading: boolean;
}

export const useCollectionsController = (): UseCollectionsControllerPayload => {
    const dispatch = useDispatch();
    const collections = useSelector(selectCollections);
    const isLoading = useSelector(selectCollectionsLoading);

    useEffectOnce(() => {
        if (!collections.length && !isLoading) {
            dispatch(loadCollectionsAsync());
        }
    });

    return {
        collections,
        isLoading,
    };
};
